module.exports = __webpack_public_path__ + "img/ClearObjectivesAgenda.96236bf6.png";